import { combineReducers } from 'redux'
import ValorizedCartReducer from './valorized/reducer'
import NotificationCartReducer from './notification/reducers'
import ModalCartReducer from './modal/reducers'

const cartReducer = combineReducers({
  notification: NotificationCartReducer,
  valorized: ValorizedCartReducer,
  modal: ModalCartReducer,
})

export default cartReducer
